export const FETCH_FOOD_SPECIFICATIONS = "FETCH_FOOD_SPECIFICATIONS"
export const ADD_FOOD_SPECIFICATIONS = "ADD_FOOD_SPECIFICATIONS"
export const UPDATE_FOOD_SPECIFICATIONS = "UPDATE_FOOD_SPECIFICATIONS"
export const DELETE_FOOD_SPECIFICATIONS = "DELETE_FOOD_SPECIFICATIONS"
export const CLEAR_FOOD_SPECIFICATIONS = "CLEAR_FOOD_SPECIFICATIONS"